/* eslint-disable no-console */
export function isEnvSwitcherEnabled(env: string) {
  return ['feqa-1', 'feqa-2', 'local', 'at1', 'demo'].includes(env);
}

export function getSelectedDevEnv(): string {
  return (
    localStorage.getItem('qaSelectedEnv') ??
    (import.meta.env.VITE_DEFAULT_API_ENV as string) ??
    'stage'
  );
}

type UrlType =
  | 'WEB_API'
  | 'COLA_URL'
  | 'FORGOTTEN_PASSWORD_LINK'
  | 'DASHBOARD_URL'
  | 'VIVUSONLINE_URL';

export function getProcessEnvUrl(url: UrlType) {
  const fallback = import.meta.env[`VITE_${url}`];

  if (!isEnvSwitcherEnabled(import.meta.env.VITE_ENV ?? '')) {
    return fallback;
  }

  const selectedDevEnv = getSelectedDevEnv().toUpperCase().replace(/-/g, '_');

  const found = import.meta.env[`VITE_${selectedDevEnv}_${url}`];

  if (!found) {
    console.error(`import.meta.env.VITE_${selectedDevEnv}_${url} not found.`);
  }

  return found ?? fallback;
}

export const getHomepageCalculatorUrl = (): string =>
  import.meta.env?.VITE_CALCULATOR || 'https://www.vivus.es';
